<div *ngFor="let page of pages()" class="page-item">
  <div class="active-item" *ngIf="page.active; else anchor">
    {{ page.label }}
  </div>
  <ng-template #anchor>
    <a class="link-item" (click)="onPageClick($event, page)" href="">
      <svg
        *ngIf="page.pageType === 'previous'"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_8982_3398)">
          <path
            d="M15.41 7.41L14 6L8 12L14 18L15.41 16.59L10.83 12L15.41 7.41Z"
            fill="#B3B6BA"
          />
        </g>
        <defs>
          <clipPath id="clip0_8982_3398">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
      <div
        class="link-label"
        *ngIf="page.pageType === 'page' || page.pageType === 'ellipsis'"
      >
        {{ page.label }}
      </div>
      <svg
        *ngIf="page.pageType === 'next'"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_8982_3399)">
          <path
            d="M10.0001 6L8.59009 7.41L13.1701 12L8.59009 16.59L10.0001 18L16.0001 12L10.0001 6Z"
            fill="#B3B6BA"
          />
        </g>
        <defs>
          <clipPath id="clip0_8982_3399">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </a>
  </ng-template>
</div>
